// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../src/assets/images/chevron-right-solid.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #ffffff;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: rgb(14, 13, 13);
}
.css-1wy0on6 > .css-1u9des2-indicatorSeparator + .css-1xc3v61-indicatorContainer, .css-1u9des2-indicatorSeparator {
    display: none !important;
}

.companyJobnames{
 margin: 0 !important;
    color: rgb(128, 128, 128);
    text-align: left;
    font-size: 10px;
    font-weight: 400;
}
.companyJobnamesDiv{
  display: block;
}

/* .fontTitle {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 6px;
}

.custom-select__control {
  border-radius: 20px;
  padding-left: 5px;
  border: 1px solid #ccc;
  min-height: 40px;
}

.custom-select__value-container {
  padding-left: 10px;
}

.custom-select__single-value {
  display: flex;
  align-items: center;
  font-weight: 500;
}

.custom-select__single-value::before {
  content: '';
  background-image: url('https://cdn-icons-png.flaticon.com/512/149/149071.png');
  background-size: cover;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-right: 8px;
  display: inline-block;
}

.approverDetails {
  margin-top: 6px;
}

.jobTitle,
.department {
  font-size: 14px;
  color: #444;
} */

.approverDetailsnew {
  margin-top: 6px;
  height:33px;
}

.approverheight{
  min-height: 107px;
}
.custom-select__control {
  border-radius: 20px;
  min-height: 40px;
  border: 1px solid #ccc;
  padding-left: 2px;
  box-shadow: none;
}

.custom-select__value-container {
  padding-left: 8px;
}

/* .custom-select__single-value {
  font-weight: 500;
  display: flex;
  align-items: center;
  background-color: #eee;
  border-radius: 20px;
  padding: 4px 8px;
} */

.custom-select__clear-indicator {
  padding: 4px;
}

.jobTitle,
.department {
  font-size: 10px;
  color: #666;
  margin-top: 2px;
}
.custom-select__single-value {
  display: flex;
  align-items: center;
  /* background: rgb(204, 204, 204); */
  border-radius: 9999px;
  /* padding: 4px 10px; */
}


/* .App-link {
  color: #043341;
} */

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}





/* Add-Form */
.rowMargin{
  margin-top: 20px !important;
}

.entries-selector .form-select{
  font-size: 12px !important;
}


.subtypes {
  padding: 0px;
}

.subtypes-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.back-to-list {
  display: flex
;
    align-items: center;
    gap: 5px;
    cursor: pointer;
    margin: 0 !important;
    font-size: 14px !important;
    color: #000 !important;
    font-weight: normal;
    text-decoration: none;
}

.subtypes-title {
  margin-bottom: 20px;
}

.form-row {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.form-group {
  margin-bottom: 20px;
}

.upload-btn {
  padding: 10px 20px;
  background-color: #ddd;
  border: none;
  cursor: pointer;
}

.upload-btn:hover {
  background-color: #bbb;
}

hr {
  margin: 30px 0;
  border: none;
  border-top: 1px solid #ccc;
}

.field-inputs {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr auto auto;
  gap: 10px;
  margin-bottom: 20px;
}

.fields-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
  font-size: 16px;
}
.custom-thead1 tr th{
  padding: 7px !important;
}
.custom-thead1 tr th{
   background-color: #f4f4f4 !important;
 padding: 7px !important;
    color: #1f5186 !important;
    text-align: center !important;
    border-bottom: 1px solid #ddd ;
}
.fields-table th,
.fields-table td {
  padding: 10px;
  border: 1px solid #ccc;
  text-align: left;
}

.fields-table th {
  background-color: #f4f4f4;
}

.delete-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: red;
}

.delete-btn:hover {
  color: darkred;
}
.required{
  color:red;
}

.action-buttons {
  display: flex;
  gap: 20px;
}

.save-btn,
.cancel-btn {
  padding: 10px 20px;
  border: none;
  cursor: pointer;
}

.save-btn {
  background-color: #0056b3;
  color: white;
}

.cancel-btn {
  background-color: #5a5a5a;
  color: white;
}

.inputType {
  height: 52px;
  padding: 8px;
  border: 1px solid rgb(204, 204, 204);
  border-radius: 4px;
  width: 100%;
}
.selectInput{
  background: #ffff;
}
.uploadButton {
background: #EEEEEE !important;
    border: 1px solid #CCCCCC !important;
    font-size: 14px !important;
    font-weight: 600 !important;
    padding: .375rem 20px !important;
    width: auto;
    margin: 0 0 0 20px !important;
    line-height: 1.5;
    border-radius: .25rem;
    max-width: 100px;
}

@media (min-width: 1450px) {
    .uploadButton {
        width: 50%;
    }
}
@media (min-width: 900px) {
    .leftymedia{
      font-size: 12px !important;
    margin: 0 !important;
    }
    .reqattachments {
        /* font-size: 12px !important; */
    }
}
@media (min-width: 1230px) {
    .leftymedia{
      font-size: 14px !important;
    margin: 0 !important;
    }
    .reqattachments {
        font-size: 14px !important;
    }
}
@media (min-width: 1335px) and (max-width: 1450px) {
  .leftymedia {
    font-size: 16px !important;
    margin: 0 !important;
  }

  .reqattachments {
    /* font-size: 16px !important; */
  }
}

@media (min-width: 1450px) {
    .reqattachments {
        width: 34% !important;
    }
}
.uploadButton:disabled {
  opacity: 0.6;
}
.no-margin {
  margin: 0 !important;
}
.fontTitle {
  display: block;
  margin-bottom: 5px;
  font-weight: 600;
  font-size: 14px;
  color: #808080;
}
.nfy .select__menu{
  width: 260px !important;
  /* border:1px solid #ff00ff */

}
.nfy .custom-select__menu{
  width: 270px;
  /* border: 1px solid #ff0000; */
}
.approverTitle {
  font-size: 13px !important;
}

.requestId{
  text-decoration: auto;
  color: #1564B7;
}
.non-clickable-text {
  color: black;
  font-weight: normal;
  text-decoration: none;
  cursor: default;
}

.InlineHeaders {
  font-size: 18px;
  font-weight: 600;
  color: #000000;
}

.inline-headers{
  font-size: 20px !important;
}

.add-button {
  width: 70px;
  height: 32px;
  padding: 5px;
  background-color: white;
  border: 2px solid #ff0000;
  color: #ff0000;
  border-radius: 5px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
}
.action-buttons{
  display: flex; 
  justify-content: flex-end;
  gap: 10px;
  text-align: right;
  border-top: 1px solid #ccc;
  padding: 20px 0;
  margin: 20px 0 0;

}
.saveButton{
  padding:.375rem 25px;
    background-color: rgb(26, 77, 143);
    color: white;
    border: none;
    border-radius: 100px;
    cursor: pointer !important;
    height: 38px;
    font-size: 16px;
}
.cancelButton{
  padding: .375rem 25px;
  background-color: rgb(90, 155, 213);
  color: white;
  border: none;
    border-radius: 100px;
    cursor: pointer !important;
    height: 38px;
    font-size: 16px;
}
.cancelButton:hover {
    background-color: #447db9;
    border-color: #447db9;
}
.noOfApprovers {
  font-size: 13px !important;
    font-weight: 600;
    color: #323232;
}
.approver-select-wrapper.has-error {
  position: relative;
}

.invalid-select .custom-select__control {
  border-color: #dc3545 !important;
}
.history-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed; /* respect column widths */
}

.history-table th,
.history-table td {
  padding: 8px;
  text-align: left;
  vertical-align: middle;
}

.widthParent tr td {
  width: auto;
  padding: 5px 10px !important;
}
.widthParent tr td:last-child {
  /* width: 40%; */
}


.col-remarks {
  overflow: hidden;
  text-overflow: ellipsis;
}


.text-danger {
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}
.tootipFile{
  border-width: 1px;
  border-radius: 14px;
  border: 1px solid #ED6C00;
  text-decoration: auto;
  background: #FFEAD9;
  color: rgba(237, 108, 0, 1);
  text-align: center;
  justify-content: space-evenly;
  align-items: center;
  display: flex;
  cursor: pointer !important;
}
.pdfCircle {
  width: 20px;
  height: 20px;
  background-color: orange;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  display: flex; 
}
.pdflogo{
  width: 14px;
}

.table-container {
  max-width: 1500px;
  margin: 20px auto;
  border: 1px solid #ccc;
  border-radius: 4px;
}

.custom-table {
  width: 100%;
  border-collapse: collapse;
}

thead th {
  background-color: #f4f4f4;
  padding: 20px;
  color: #1f5186;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.action-header {
  text-align: center;
  border-right: 1px solid #ddd;
  width: 10%;
}

tbody td {
  padding: 15px 10px 15px 20px;
  border-bottom: 1px solid #ddd;
}

.action-cell {
  text-align: center;
  border-right: 1px solid #ddd;
}

.delete-button {
  background-color: transparent;
  border: none;
  cursor: pointer;
}

.centerAlign{
  text-align: center !important;
}
.flexClass{
  display: flex
  ;
     
      align-items: center;
      justify-content: space-between;
}
.chip {
  margin-bottom: 1px !important;
  padding: 2px 10px !important;
}

/* Base mobile sidebar styles */
.sidebar.mobile-visible {
  position: fixed;
  top: 0;
  right: 0;
  width: 250px;
  height: 100vh;
  z-index: 1050;
  background-color: #1E4469;
  transform: translateX(0%);
  transition: transform 0.3s ease-in-out;
}

.sidebar.mobile-hidden {
  position: fixed;
  top: 0;
  right: 0;
  width: 250px;
  height: 100vh;
  z-index: 1050;
  background-color: #1E4469;
  transform: translateX(100%);
  transition: transform 0.3s ease-in-out;
}

@media (max-width: 1024px) {
  .action-buttons.oneD .cancelButton, .action-buttons.oneD .saveButton {
      width: 100%;
      margin-bottom: 15px;
  }
  .action-buttons.oneD {
    display: inline-block;
    width: 100%;
}
}

.nameUser{
    color: rgb(128, 128, 128);
    text-align: left;
    font-weight: 400;
    margin: 0px;
    font-size: 12px;

}

/* Request Page */
.requestHeader{
  font-size: 20px;
    font-weight: 600;
    color: #323232;
    margin: 0 0 8px;
}
.breadcrumb{
  margin: 0 !important;
}
.breadcrumb li {
    font-size: 16px;
    font-weight: 400;
    color: #999999;
}
.breadcrumb-item+.breadcrumb-item::before {
    content: "" !important;
    margin-top: 5px !important;
}
.breadcrumb-item+.breadcrumb-item::before {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center right;
    content: "";
    height: 14px;
    margin: 0 8px 0 2px;
    color: #6c757d !important;
    background-size: 85%;
}
.inner-heading{
  border-bottom: 1px solid #CCCCCC;
}
.textDecNone{
  text-decoration: none !important;
  cursor: pointer;
}
.textDecNone:hover{
  text-decoration: underline !important;
}
.form-control:hover{
  border-color: #ff585d !important;
}
#ackModalContent{
  padding: 0;
}
#ackModalHeader{
  background: #679BD3;
}
.acktitle{
  font-size: 18px;
    text-transform: uppercase;
    color: #fff;
    font-weight: 600;
}
#ackFooter{
  padding: 1rem;
}
#ackModalClose{
  border-radius: 100px;
    padding: .375rem 25px;
    background-color: #1F5186;
    border-color: #1F5186;
    color: #fff;
    display: inline-block;
    font-weight: 400;
    font-size: 1rem;
    line-height: 1.5;
}
.text-danger{
  text-align: left;
    font-size: 13px;
    font-weight: 400;
}
.text-success {
  text-align: left;
    font-size: 13px;
    font-weight: 400;
}
.form-.form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"], .was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"]{
 --bs-form-select-bg-icon:none !important;
}
.invalidForm{
  border-color: #dc3545 !important;
}
.historylog{
  font-size: 24px;
    color: #323232;
    font-weight: 700;
    text-transform: uppercase;
    border-left: 3px solid #ED6C00;
    padding: 0 0 0 5px;
    line-height: 25px;
}
.bgtransparent{
  background-color: transparent !important;
  color: #323232 !important;
}
@media (max-width: 768px) {
    .breadcrumb li {
        font-size: 12px;
    }
}

.ql-font-open-sans::before {
  content: 'Open Sans';
  font-family: 'Open Sans', sans-serif;
}

.ql-font-arial::before {
  content: 'Arial';
  font-family: Arial, sans-serif;
}

.ql-font-arial-black::before {
  content: 'Arial Black';
  font-family: 'Arial Black', Gadget, sans-serif;
}

.ql-font-comic-sans-ms::before {
  content: 'Comic Sans MS';
  font-family: 'Comic Sans MS', cursive, sans-serif;
}

.ql-font-courier-new::before {
  content: 'Courier New';
  font-family: 'Courier New', Courier, monospace;
}

.ql-font-helvetica::before {
  content: 'Helvetica';
  font-family: Helvetica, sans-serif;
}

.ql-font-impact::before {
  content: 'Impact';
  font-family: Impact, Charcoal, sans-serif;
}

.ql-font-tahoma::before {
  content: 'Tahoma';
  font-family: Tahoma, Geneva, sans-serif;
}

.ql-font-times-new-roman::before {
  content: 'Times New Roman';
  font-family: 'Times New Roman', Times, serif;
}

.ql-font-verdana::before {
  content: 'Verdana';
  font-family: Verdana, Geneva, sans-serif;
}

.topPositionOOOffice{
  display:flex;
  margin-top: 60px;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,sBAAsB;AACxB;AACA;IACI,wBAAwB;AAC5B;;AAEA;CACC,oBAAoB;IACjB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;AACA;EACE,cAAc;AAChB;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;GA0CG;;AAEH;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;;;;GAOG;;AAEH;EACE,YAAY;AACd;;AAEA;;EAEE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,qBAAqB;EACrB,uBAAuB;AACzB;;;AAGA;;GAEG;;AAEH;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;;;;;AAMA,aAAa;AACb;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;;AAGA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE;AACF;IACI,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,oBAAoB;IACpB,0BAA0B;IAC1B,sBAAsB;IACtB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;GACG,oCAAoC;CACtC,uBAAuB;IACpB,yBAAyB;IACzB,6BAA6B;IAC7B,8BAA8B;AAClC;AACA;;EAEE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,cAAc;AAChB;AACA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,iBAAiB;AACnB;AACA;AACA,8BAA8B;IAC1B,oCAAoC;IACpC,0BAA0B;IAC1B,2BAA2B;IAC3B,gCAAgC;IAChC,WAAW;IACX,6BAA6B;IAC7B,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI;QACI,UAAU;IACd;AACJ;AACA;IACI;MACE,0BAA0B;IAC5B,oBAAoB;IACpB;IACA;QACI,gCAAgC;IACpC;AACJ;AACA;IACI;MACE,0BAA0B;IAC5B,oBAAoB;IACpB;IACA;QACI,0BAA0B;IAC9B;AACJ;AACA;EACE;IACE,0BAA0B;IAC1B,oBAAoB;EACtB;;EAEA;IACE,gCAAgC;EAClC;AACF;;AAEA;IACI;QACI,qBAAqB;IACzB;AACJ;AACA;EACE,YAAY;AACd;AACA;EACE,oBAAoB;AACtB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,6BAA6B;;AAE/B;AACA;EACE,YAAY;EACZ,+BAA+B;AACjC;AACA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,iBAAiB;EACjB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;;AAElB;AACA;EACE,oBAAoB;IAClB,kCAAkC;IAClC,YAAY;IACZ,YAAY;IACZ,oBAAoB;IACpB,0BAA0B;IAC1B,YAAY;IACZ,eAAe;AACnB;AACA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,YAAY;EACZ,YAAY;IACV,oBAAoB;IACpB,0BAA0B;IAC1B,YAAY;IACZ,eAAe;AACnB;AACA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;AACA;EACE,0BAA0B;IACxB,gBAAgB;IAChB,cAAc;AAClB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB,EAAE,0BAA0B;AACjD;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,4BAA4B;AAC9B;AACA;EACE,gBAAgB;AAClB;;;AAGA;EACE,gBAAgB;EAChB,uBAAuB;AACzB;;;AAGA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,6BAA6B;EAC7B,mBAAmB;EACnB,aAAa;EACb,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,UAAU;AACZ;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;AACA;EACE;EACA;;MAEI,mBAAmB;MACnB,8BAA8B;AACpC;AACA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA,+BAA+B;AAC/B;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA;EACE;MACI,WAAW;MACX,mBAAmB;EACvB;EACA;IACE,qBAAqB;IACrB,WAAW;AACf;AACA;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,eAAe;;AAEnB;;AAEA,iBAAiB;AACjB;EACE,eAAe;IACb,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;AACA;EACE,oBAAoB;AACtB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,sBAAsB;IACtB,0BAA0B;AAC9B;AACA;IACI,0EAAoF;IACpF,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,oBAAoB;AACxB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;IACb,yBAAyB;IACzB,WAAW;IACX,gBAAgB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;IAClB,qBAAqB;IACrB,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;AACpB;AACA;EACE,gBAAgB;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;EACE,gBAAgB;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;CACC,wCAAwC;AACzC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,eAAe;IACb,cAAc;IACd,gBAAgB;IAChB,yBAAyB;IACzB,8BAA8B;IAC9B,kBAAkB;IAClB,iBAAiB;AACrB;AACA;EACE,wCAAwC;EACxC,yBAAyB;AAC3B;AACA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;EACE,oBAAoB;EACpB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;EACxB,iDAAiD;AACnD;;AAEA;EACE,sBAAsB;EACtB,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA;EACE,0BAA0B;EAC1B,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":[".App {\r\n  text-align: center;\r\n}\r\n\r\n.App-logo {\r\n  height: 40vmin;\r\n  pointer-events: none;\r\n}\r\n\r\n@media (prefers-reduced-motion: no-preference) {\r\n  .App-logo {\r\n    animation: App-logo-spin infinite 20s linear;\r\n  }\r\n}\r\n\r\n.App-header {\r\n  background-color: #ffffff;\r\n  min-height: 100vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: calc(10px + 2vmin);\r\n  color: rgb(14, 13, 13);\r\n}\r\n.css-1wy0on6 > .css-1u9des2-indicatorSeparator + .css-1xc3v61-indicatorContainer, .css-1u9des2-indicatorSeparator {\r\n    display: none !important;\r\n}\r\n\r\n.companyJobnames{\r\n margin: 0 !important;\r\n    color: rgb(128, 128, 128);\r\n    text-align: left;\r\n    font-size: 10px;\r\n    font-weight: 400;\r\n}\r\n.companyJobnamesDiv{\r\n  display: block;\r\n}\r\n\r\n/* .fontTitle {\r\n  font-weight: 600;\r\n  font-size: 16px;\r\n  margin-bottom: 6px;\r\n}\r\n\r\n.custom-select__control {\r\n  border-radius: 20px;\r\n  padding-left: 5px;\r\n  border: 1px solid #ccc;\r\n  min-height: 40px;\r\n}\r\n\r\n.custom-select__value-container {\r\n  padding-left: 10px;\r\n}\r\n\r\n.custom-select__single-value {\r\n  display: flex;\r\n  align-items: center;\r\n  font-weight: 500;\r\n}\r\n\r\n.custom-select__single-value::before {\r\n  content: '';\r\n  background-image: url('https://cdn-icons-png.flaticon.com/512/149/149071.png');\r\n  background-size: cover;\r\n  width: 20px;\r\n  height: 20px;\r\n  border-radius: 50%;\r\n  margin-right: 8px;\r\n  display: inline-block;\r\n}\r\n\r\n.approverDetails {\r\n  margin-top: 6px;\r\n}\r\n\r\n.jobTitle,\r\n.department {\r\n  font-size: 14px;\r\n  color: #444;\r\n} */\r\n\r\n.approverDetailsnew {\r\n  margin-top: 6px;\r\n  height:33px;\r\n}\r\n\r\n.approverheight{\r\n  min-height: 107px;\r\n}\r\n.custom-select__control {\r\n  border-radius: 20px;\r\n  min-height: 40px;\r\n  border: 1px solid #ccc;\r\n  padding-left: 2px;\r\n  box-shadow: none;\r\n}\r\n\r\n.custom-select__value-container {\r\n  padding-left: 8px;\r\n}\r\n\r\n/* .custom-select__single-value {\r\n  font-weight: 500;\r\n  display: flex;\r\n  align-items: center;\r\n  background-color: #eee;\r\n  border-radius: 20px;\r\n  padding: 4px 8px;\r\n} */\r\n\r\n.custom-select__clear-indicator {\r\n  padding: 4px;\r\n}\r\n\r\n.jobTitle,\r\n.department {\r\n  font-size: 10px;\r\n  color: #666;\r\n  margin-top: 2px;\r\n}\r\n.custom-select__single-value {\r\n  display: flex;\r\n  align-items: center;\r\n  /* background: rgb(204, 204, 204); */\r\n  border-radius: 9999px;\r\n  /* padding: 4px 10px; */\r\n}\r\n\r\n\r\n/* .App-link {\r\n  color: #043341;\r\n} */\r\n\r\n@keyframes App-logo-spin {\r\n  from {\r\n    transform: rotate(0deg);\r\n  }\r\n\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n\r\n\r\n\r\n\r\n/* Add-Form */\r\n.rowMargin{\r\n  margin-top: 20px !important;\r\n}\r\n\r\n.entries-selector .form-select{\r\n  font-size: 12px !important;\r\n}\r\n\r\n\r\n.subtypes {\r\n  padding: 0px;\r\n}\r\n\r\n.subtypes-header {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n}\r\n\r\n.back-to-list {\r\n  display: flex\r\n;\r\n    align-items: center;\r\n    gap: 5px;\r\n    cursor: pointer;\r\n    margin: 0 !important;\r\n    font-size: 14px !important;\r\n    color: #000 !important;\r\n    font-weight: normal;\r\n    text-decoration: none;\r\n}\r\n\r\n.subtypes-title {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.form-row {\r\n  display: flex;\r\n  gap: 20px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.form-group {\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.upload-btn {\r\n  padding: 10px 20px;\r\n  background-color: #ddd;\r\n  border: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.upload-btn:hover {\r\n  background-color: #bbb;\r\n}\r\n\r\nhr {\r\n  margin: 30px 0;\r\n  border: none;\r\n  border-top: 1px solid #ccc;\r\n}\r\n\r\n.field-inputs {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr 1fr auto auto;\r\n  gap: 10px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.fields-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  margin-bottom: 20px;\r\n  font-size: 16px;\r\n}\r\n.custom-thead1 tr th{\r\n  padding: 7px !important;\r\n}\r\n.custom-thead1 tr th{\r\n   background-color: #f4f4f4 !important;\r\n padding: 7px !important;\r\n    color: #1f5186 !important;\r\n    text-align: center !important;\r\n    border-bottom: 1px solid #ddd ;\r\n}\r\n.fields-table th,\r\n.fields-table td {\r\n  padding: 10px;\r\n  border: 1px solid #ccc;\r\n  text-align: left;\r\n}\r\n\r\n.fields-table th {\r\n  background-color: #f4f4f4;\r\n}\r\n\r\n.delete-btn {\r\n  background: none;\r\n  border: none;\r\n  cursor: pointer;\r\n  color: red;\r\n}\r\n\r\n.delete-btn:hover {\r\n  color: darkred;\r\n}\r\n.required{\r\n  color:red;\r\n}\r\n\r\n.action-buttons {\r\n  display: flex;\r\n  gap: 20px;\r\n}\r\n\r\n.save-btn,\r\n.cancel-btn {\r\n  padding: 10px 20px;\r\n  border: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.save-btn {\r\n  background-color: #0056b3;\r\n  color: white;\r\n}\r\n\r\n.cancel-btn {\r\n  background-color: #5a5a5a;\r\n  color: white;\r\n}\r\n\r\n.inputType {\r\n  height: 52px;\r\n  padding: 8px;\r\n  border: 1px solid rgb(204, 204, 204);\r\n  border-radius: 4px;\r\n  width: 100%;\r\n}\r\n.selectInput{\r\n  background: #ffff;\r\n}\r\n.uploadButton {\r\nbackground: #EEEEEE !important;\r\n    border: 1px solid #CCCCCC !important;\r\n    font-size: 14px !important;\r\n    font-weight: 600 !important;\r\n    padding: .375rem 20px !important;\r\n    width: auto;\r\n    margin: 0 0 0 20px !important;\r\n    line-height: 1.5;\r\n    border-radius: .25rem;\r\n    max-width: 100px;\r\n}\r\n\r\n@media (min-width: 1450px) {\r\n    .uploadButton {\r\n        width: 50%;\r\n    }\r\n}\r\n@media (min-width: 900px) {\r\n    .leftymedia{\r\n      font-size: 12px !important;\r\n    margin: 0 !important;\r\n    }\r\n    .reqattachments {\r\n        /* font-size: 12px !important; */\r\n    }\r\n}\r\n@media (min-width: 1230px) {\r\n    .leftymedia{\r\n      font-size: 14px !important;\r\n    margin: 0 !important;\r\n    }\r\n    .reqattachments {\r\n        font-size: 14px !important;\r\n    }\r\n}\r\n@media (min-width: 1335px) and (max-width: 1450px) {\r\n  .leftymedia {\r\n    font-size: 16px !important;\r\n    margin: 0 !important;\r\n  }\r\n\r\n  .reqattachments {\r\n    /* font-size: 16px !important; */\r\n  }\r\n}\r\n\r\n@media (min-width: 1450px) {\r\n    .reqattachments {\r\n        width: 34% !important;\r\n    }\r\n}\r\n.uploadButton:disabled {\r\n  opacity: 0.6;\r\n}\r\n.no-margin {\r\n  margin: 0 !important;\r\n}\r\n.fontTitle {\r\n  display: block;\r\n  margin-bottom: 5px;\r\n  font-weight: 600;\r\n  font-size: 14px;\r\n  color: #808080;\r\n}\r\n.nfy .select__menu{\r\n  width: 260px !important;\r\n  /* border:1px solid #ff00ff */\r\n\r\n}\r\n.nfy .custom-select__menu{\r\n  width: 270px;\r\n  /* border: 1px solid #ff0000; */\r\n}\r\n.approverTitle {\r\n  font-size: 13px !important;\r\n}\r\n\r\n.requestId{\r\n  text-decoration: auto;\r\n  color: #1564B7;\r\n}\r\n.non-clickable-text {\r\n  color: black;\r\n  font-weight: normal;\r\n  text-decoration: none;\r\n  cursor: default;\r\n}\r\n\r\n.InlineHeaders {\r\n  font-size: 18px;\r\n  font-weight: 600;\r\n  color: #000000;\r\n}\r\n\r\n.inline-headers{\r\n  font-size: 20px !important;\r\n}\r\n\r\n.add-button {\r\n  width: 70px;\r\n  height: 32px;\r\n  padding: 5px;\r\n  background-color: white;\r\n  border: 2px solid #ff0000;\r\n  color: #ff0000;\r\n  border-radius: 5px;\r\n  cursor: pointer;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 5px;\r\n}\r\n.action-buttons{\r\n  display: flex; \r\n  justify-content: flex-end;\r\n  gap: 10px;\r\n  text-align: right;\r\n  border-top: 1px solid #ccc;\r\n  padding: 20px 0;\r\n  margin: 20px 0 0;\r\n\r\n}\r\n.saveButton{\r\n  padding:.375rem 25px;\r\n    background-color: rgb(26, 77, 143);\r\n    color: white;\r\n    border: none;\r\n    border-radius: 100px;\r\n    cursor: pointer !important;\r\n    height: 38px;\r\n    font-size: 16px;\r\n}\r\n.cancelButton{\r\n  padding: .375rem 25px;\r\n  background-color: rgb(90, 155, 213);\r\n  color: white;\r\n  border: none;\r\n    border-radius: 100px;\r\n    cursor: pointer !important;\r\n    height: 38px;\r\n    font-size: 16px;\r\n}\r\n.cancelButton:hover {\r\n    background-color: #447db9;\r\n    border-color: #447db9;\r\n}\r\n.noOfApprovers {\r\n  font-size: 13px !important;\r\n    font-weight: 600;\r\n    color: #323232;\r\n}\r\n.approver-select-wrapper.has-error {\r\n  position: relative;\r\n}\r\n\r\n.invalid-select .custom-select__control {\r\n  border-color: #dc3545 !important;\r\n}\r\n.history-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n  table-layout: fixed; /* respect column widths */\r\n}\r\n\r\n.history-table th,\r\n.history-table td {\r\n  padding: 8px;\r\n  text-align: left;\r\n  vertical-align: middle;\r\n}\r\n\r\n.widthParent tr td {\r\n  width: auto;\r\n  padding: 5px 10px !important;\r\n}\r\n.widthParent tr td:last-child {\r\n  /* width: 40%; */\r\n}\r\n\r\n\r\n.col-remarks {\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n\r\n.text-danger {\r\n  color: #dc3545;\r\n  font-size: 0.875rem;\r\n  margin-top: 0.25rem;\r\n}\r\n.tootipFile{\r\n  border-width: 1px;\r\n  border-radius: 14px;\r\n  border: 1px solid #ED6C00;\r\n  text-decoration: auto;\r\n  background: #FFEAD9;\r\n  color: rgba(237, 108, 0, 1);\r\n  text-align: center;\r\n  justify-content: space-evenly;\r\n  align-items: center;\r\n  display: flex;\r\n  cursor: pointer !important;\r\n}\r\n.pdfCircle {\r\n  width: 20px;\r\n  height: 20px;\r\n  background-color: orange;\r\n  border-radius: 50%;\r\n  align-items: center;\r\n  justify-content: center;\r\n  display: flex; \r\n}\r\n.pdflogo{\r\n  width: 14px;\r\n}\r\n\r\n.table-container {\r\n  max-width: 1500px;\r\n  margin: 20px auto;\r\n  border: 1px solid #ccc;\r\n  border-radius: 4px;\r\n}\r\n\r\n.custom-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n}\r\n\r\nthead th {\r\n  background-color: #f4f4f4;\r\n  padding: 20px;\r\n  color: #1f5186;\r\n  text-align: left;\r\n  border-bottom: 1px solid #ddd;\r\n}\r\n\r\n.action-header {\r\n  text-align: center;\r\n  border-right: 1px solid #ddd;\r\n  width: 10%;\r\n}\r\n\r\ntbody td {\r\n  padding: 15px 10px 15px 20px;\r\n  border-bottom: 1px solid #ddd;\r\n}\r\n\r\n.action-cell {\r\n  text-align: center;\r\n  border-right: 1px solid #ddd;\r\n}\r\n\r\n.delete-button {\r\n  background-color: transparent;\r\n  border: none;\r\n  cursor: pointer;\r\n}\r\n\r\n.centerAlign{\r\n  text-align: center !important;\r\n}\r\n.flexClass{\r\n  display: flex\r\n  ;\r\n     \r\n      align-items: center;\r\n      justify-content: space-between;\r\n}\r\n.chip {\r\n  margin-bottom: 1px !important;\r\n  padding: 2px 10px !important;\r\n}\r\n\r\n/* Base mobile sidebar styles */\r\n.sidebar.mobile-visible {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  width: 250px;\r\n  height: 100vh;\r\n  z-index: 1050;\r\n  background-color: #1E4469;\r\n  transform: translateX(0%);\r\n  transition: transform 0.3s ease-in-out;\r\n}\r\n\r\n.sidebar.mobile-hidden {\r\n  position: fixed;\r\n  top: 0;\r\n  right: 0;\r\n  width: 250px;\r\n  height: 100vh;\r\n  z-index: 1050;\r\n  background-color: #1E4469;\r\n  transform: translateX(100%);\r\n  transition: transform 0.3s ease-in-out;\r\n}\r\n\r\n@media (max-width: 1024px) {\r\n  .action-buttons.oneD .cancelButton, .action-buttons.oneD .saveButton {\r\n      width: 100%;\r\n      margin-bottom: 15px;\r\n  }\r\n  .action-buttons.oneD {\r\n    display: inline-block;\r\n    width: 100%;\r\n}\r\n}\r\n\r\n.nameUser{\r\n    color: rgb(128, 128, 128);\r\n    text-align: left;\r\n    font-weight: 400;\r\n    margin: 0px;\r\n    font-size: 12px;\r\n\r\n}\r\n\r\n/* Request Page */\r\n.requestHeader{\r\n  font-size: 20px;\r\n    font-weight: 600;\r\n    color: #323232;\r\n    margin: 0 0 8px;\r\n}\r\n.breadcrumb{\r\n  margin: 0 !important;\r\n}\r\n.breadcrumb li {\r\n    font-size: 16px;\r\n    font-weight: 400;\r\n    color: #999999;\r\n}\r\n.breadcrumb-item+.breadcrumb-item::before {\r\n    content: \"\" !important;\r\n    margin-top: 5px !important;\r\n}\r\n.breadcrumb-item+.breadcrumb-item::before {\r\n    background: url(../src/assets/images/chevron-right-solid.svg) no-repeat center right;\r\n    content: \"\";\r\n    height: 14px;\r\n    margin: 0 8px 0 2px;\r\n    color: #6c757d !important;\r\n    background-size: 85%;\r\n}\r\n.inner-heading{\r\n  border-bottom: 1px solid #CCCCCC;\r\n}\r\n.textDecNone{\r\n  text-decoration: none !important;\r\n  cursor: pointer;\r\n}\r\n.textDecNone:hover{\r\n  text-decoration: underline !important;\r\n}\r\n.form-control:hover{\r\n  border-color: #ff585d !important;\r\n}\r\n#ackModalContent{\r\n  padding: 0;\r\n}\r\n#ackModalHeader{\r\n  background: #679BD3;\r\n}\r\n.acktitle{\r\n  font-size: 18px;\r\n    text-transform: uppercase;\r\n    color: #fff;\r\n    font-weight: 600;\r\n}\r\n#ackFooter{\r\n  padding: 1rem;\r\n}\r\n#ackModalClose{\r\n  border-radius: 100px;\r\n    padding: .375rem 25px;\r\n    background-color: #1F5186;\r\n    border-color: #1F5186;\r\n    color: #fff;\r\n    display: inline-block;\r\n    font-weight: 400;\r\n    font-size: 1rem;\r\n    line-height: 1.5;\r\n}\r\n.text-danger{\r\n  text-align: left;\r\n    font-size: 13px;\r\n    font-weight: 400;\r\n}\r\n.text-success {\r\n  text-align: left;\r\n    font-size: 13px;\r\n    font-weight: 400;\r\n}\r\n.form-.form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size=\"1\"], .was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size=\"1\"]{\r\n --bs-form-select-bg-icon:none !important;\r\n}\r\n.invalidForm{\r\n  border-color: #dc3545 !important;\r\n}\r\n.historylog{\r\n  font-size: 24px;\r\n    color: #323232;\r\n    font-weight: 700;\r\n    text-transform: uppercase;\r\n    border-left: 3px solid #ED6C00;\r\n    padding: 0 0 0 5px;\r\n    line-height: 25px;\r\n}\r\n.bgtransparent{\r\n  background-color: transparent !important;\r\n  color: #323232 !important;\r\n}\r\n@media (max-width: 768px) {\r\n    .breadcrumb li {\r\n        font-size: 12px;\r\n    }\r\n}\r\n\r\n.ql-font-open-sans::before {\r\n  content: 'Open Sans';\r\n  font-family: 'Open Sans', sans-serif;\r\n}\r\n\r\n.ql-font-arial::before {\r\n  content: 'Arial';\r\n  font-family: Arial, sans-serif;\r\n}\r\n\r\n.ql-font-arial-black::before {\r\n  content: 'Arial Black';\r\n  font-family: 'Arial Black', Gadget, sans-serif;\r\n}\r\n\r\n.ql-font-comic-sans-ms::before {\r\n  content: 'Comic Sans MS';\r\n  font-family: 'Comic Sans MS', cursive, sans-serif;\r\n}\r\n\r\n.ql-font-courier-new::before {\r\n  content: 'Courier New';\r\n  font-family: 'Courier New', Courier, monospace;\r\n}\r\n\r\n.ql-font-helvetica::before {\r\n  content: 'Helvetica';\r\n  font-family: Helvetica, sans-serif;\r\n}\r\n\r\n.ql-font-impact::before {\r\n  content: 'Impact';\r\n  font-family: Impact, Charcoal, sans-serif;\r\n}\r\n\r\n.ql-font-tahoma::before {\r\n  content: 'Tahoma';\r\n  font-family: Tahoma, Geneva, sans-serif;\r\n}\r\n\r\n.ql-font-times-new-roman::before {\r\n  content: 'Times New Roman';\r\n  font-family: 'Times New Roman', Times, serif;\r\n}\r\n\r\n.ql-font-verdana::before {\r\n  content: 'Verdana';\r\n  font-family: Verdana, Geneva, sans-serif;\r\n}\r\n\r\n.topPositionOOOffice{\r\n  display:flex;\r\n  margin-top: 60px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
